import { Controller } from "@hotwired/stimulus"

// Управление существующими картинками галереи в админке (правка подписи, удаление).
// Запросы идут через fetch, чтобы не вкладывать HTML-формы внутрь основной формы
// редактирования страницы (вложенные формы — невалидный HTML, и браузер их «склеивает»).
export default class extends Controller {
  static targets = ["status"]

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  async saveCaption(event) {
    event.preventDefault()
    const item = event.currentTarget.closest(".gallery-admin-item")
    const url = item.dataset.captionUrl
    const input = item.querySelector(".gallery-admin-caption-input")
    if (!url || !input) return

    const data = new FormData()
    data.append("caption", input.value)
    data.append("_method", "patch")
    data.append("authenticity_token", this.csrfToken())

    this.flash(item, "Сохраняю…", "pending")
    try {
      const res = await fetch(url, {
        method: "POST",
        body: data,
        headers: { "Accept": "text/html", "X-CSRF-Token": this.csrfToken() },
        redirect: "manual"
      })
      if (res.ok || res.type === "opaqueredirect") {
        this.flash(item, "Сохранено", "success")
      } else {
        this.flash(item, "Ошибка " + res.status, "error")
      }
    } catch (e) {
      this.flash(item, "Ошибка сети", "error")
    }
  }

  async destroy(event) {
    event.preventDefault()
    if (!window.confirm("Удалить изображение?")) return
    const item = event.currentTarget.closest(".gallery-admin-item")
    const url = item.dataset.deleteUrl
    if (!url) return

    const data = new FormData()
    data.append("_method", "delete")
    data.append("authenticity_token", this.csrfToken())

    try {
      const res = await fetch(url, {
        method: "POST",
        body: data,
        headers: { "Accept": "text/html", "X-CSRF-Token": this.csrfToken() },
        redirect: "manual"
      })
      if (res.ok || res.type === "opaqueredirect") {
        item.remove()
      } else {
        this.flash(item, "Ошибка " + res.status, "error")
      }
    } catch (e) {
      this.flash(item, "Ошибка сети", "error")
    }
  }

  flash(item, msg, type) {
    let status = item.querySelector(".gallery-admin-status")
    if (!status) {
      status = document.createElement("div")
      status.className = "gallery-admin-status"
      item.appendChild(status)
    }
    status.textContent = msg
    status.dataset.type = type
    if (type !== "pending") {
      clearTimeout(status._t)
      status._t = setTimeout(() => { status.textContent = "" }, 2500)
    }
  }
}
